import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Compass } from 'lucide-react';

/**
 * Catch-all route.
 *
 * Without one, any URL that did not match rendered a blank area under the
 * navigation — indistinguishable from a page that had failed to load.
 */
const NotFoundPage: React.FC = () => {
  const location = useLocation();

  return (
    <div className="container mx-auto px-4 py-20 text-center">
      <div className="mx-auto w-14 h-14 rounded-full bg-coral-500/10 flex items-center justify-center">
        <Compass className="w-7 h-7 text-coral-500" />
      </div>
      <h1 className="mt-4 text-2xl font-semibold text-stone-900 dark:text-white">
        Page not found
      </h1>
      <p className="mt-2 text-stone-600 dark:text-foreground-muted">
        Nothing lives at <code className="font-mono">{location.pathname}</code>.
      </p>
      <div className="mt-6 flex items-center justify-center gap-3">
        <Link
          to="/dashboard"
          className="px-4 py-2 rounded-lg bg-coral-600 hover:bg-coral-700 text-white text-sm font-medium"
        >
          Go to Dashboard
        </Link>
        <Link
          to="/guide"
          className="px-4 py-2 rounded-lg border border-stone-300 dark:border-stone-600 text-sm"
        >
          Open the guide
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
